// SignIn.js
import React from 'react';
import {
  AppBar, Toolbar, Typography, Container, CssBaseline, ThemeProvider,
  Box, Button
} from '@mui/material';
import { createTheme } from '@mui/material/styles';
import logo from '../logo.png';
import './styles.css';
import Footer from '../pages/Footer';
import { v4 as uuidv4 } from 'uuid';
import sha256 from 'crypto-js/sha256';
import Base64 from 'crypto-js/enc-base64url';

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: 'rgb(18,82,166)',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Times New Roman", Times, serif',
  },
});

export default function SignIn() {
  const handleSignIn = () => {
    const codeVerifier = uuidv4() + uuidv4();
    const codeChallenge = Base64.stringify(sha256(codeVerifier));
    localStorage.setItem('fayda_code_verifier', codeVerifier);

    const CLIENT_ID = '419258';
    const REDIRECT_URI = 'http://localhost:3000/callback';
    const AUTHORIZATION_ENDPOINT = 'https://esignet.ltsstaging.fayda.et/authorize';
    const SCOPE = 'openid profile email';
    const STATE = uuidv4();
    const ACR_VALUES = 'mosip:idp:acr:generated-code:biometrics';

    const claims = {
      userinfo: {
        name: { essential: true },
        phone_number: { essential: true },
        email: { essential: true },
        picture: { essential: true },
        gender: { essential: true },
        birthdate: { essential: true },
        address: { essential: true },
      },
    };

    const encodedClaims = encodeURIComponent(JSON.stringify(claims));

    const authUrl = `${AUTHORIZATION_ENDPOINT}?client_id=${CLIENT_ID}&response_type=code&redirect_uri=${encodeURIComponent(
      REDIRECT_URI
    )}&scope=${encodeURIComponent(SCOPE)}&state=${STATE}&code_challenge=${codeChallenge}&code_challenge_method=S256&acr_values=${ACR_VALUES}&claims=${encodedClaims}`;

    window.location.href = authUrl;
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <div className="page-container">
        <CssBaseline />
        <AppBar position="static">
          <Toolbar>
            <img src={logo} alt="Ministry of Education Logo" style={{ maxHeight: '70px', marginRight: '20px' }} />
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
              Ministry of Education
            </Typography>
          </Toolbar>
        </AppBar>

        <Container component="main" sx={{ maxWidth: 'lg' }}>
          <CssBaseline />

          <Typography component="h1" variant="h5" align="center" sx={{ mt: 6 }}>
            Ethiopian University Exit Exam (EUEE) Registration
          </Typography>

          <Typography component="p" align="center" sx={{ mt: 2 }}>
            Follow Registration guide <a href="https://youtu.be/ktp91HHonvc">here (Video)</a>
          </Typography>

          <Box sx={{ mt: 8, display: 'flex', justifyContent: 'center' }}>
            <Button variant="contained" color="primary" size="large" onClick={handleSignIn}>
              Authenticate with Fayda
            </Button>
          </Box>
        </Container>

        <Footer />
      </div>
    </ThemeProvider>
  );
}
